import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function 获取网格地图
 * @desc 案件柱状图
 * @returns {Object}
 */
 const getGridMapData = () => {
    return axios
      .get(`/api/v1/projects/${getProjectId()}/ucases/xc_community_mesh`)
      .then(checkResponse);
  };

  /**
 * @function 更新项目配置
 * @desc 案件柱状图
 * @returns {Object}
 */
 const putConfiged = (data) => {
    return axios
      .put(`/api/v1/projects/${getProjectId()}/configure`, data)
      .then(checkResponse);
  };

/**
 * @function getMeshList
 * @desc 获取网格列表数据
 * @returns {Object}
 */
const getMeshList = (query) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/ucases/xc_community_mesh_list?${query}`,)
    .then(checkResponse);
};

  /**
 * @function 获取项目配置
 * @desc 案件柱状图
 * @returns {Object}
 */
   const getConfiged = () => {
    return axios
      .get(`/api/v1/projects/${getProjectId()}/configured`)
      .then(checkResponse);
  };

/**
 * @function 获取详情
 * @desc 案件柱状图
 * @returns {Object}
 */
    const getGridDetail = (id,page) => {
    return axios
        .get(`/api/v1/projects/${getProjectId()}/ucases/xc_community_mesh_item_list?id=${id}&page=${page}&per=10`)
        .then(checkResponse);
    };
export {getGridMapData,putConfiged, getMeshList,getConfiged,getGridDetail}